define('modules/icons/icon_view',[
  'backbone',
  'jquery',
  '_',

  './icon_model',
  'text!./icon_template.html'],
  function(
    Backbone, $, _,

    IconModel,
    icon_template

    ) {
    'use strict';
    var View = Backbone.View.extend({
      initialize: function(opts) {
        _.extend(this, opts);
        this.model = new IconModel({name: this.name});
        this.listenTo(this.model, 'change', function(model) {
          this.updateIcon();
        }, this);

        this.listenTo(Backbone, 'icon.' + this.name + '.count', function(count, add) {
          if(add) {
            count = this.model.get('count') + count;
          }
          this.model.set('count', count);
        }, this);

        this.listenTo(Backbone, 'icon.' + this.name + '.badge', function(show) {
          this.model.set('show_badge', show);
        }, this);

        this.render();
      },



      template: _.template(icon_template),
      tagName: 'span',
      className: 'icon',
      render: function() {
        this.$el.html(this.template(this.model.toJSON())).addClass('icon-' + this.model.get('name'));
        return this;
      },

      updateIcon: function() {
        if(this.model.get('show_badge') && this.model.get('count') > 0) {
          this.$el.addClass('show-badge');
        } else {
          this.$el.removeClass('show-badge');
        }
        this.$el.attr('data-count', this.model.get('count'));
        return this;
      },

      remove: function() {
        this.$el.empty();
        this.stopListening();
        this.$el.off();
        return this;
      }
    });
    return View;
  });
